<template>
    <div>
        <a-upload accept=".jpeg,.jpg,.png,.gif,.bmp,.tiff,.tif,.webp,.svg,.ico,.raw" :disabled="isShow"
            :action="uploadUrl" :maxCount="count" multiple list-type="picture-card" :file-list="ID_image"
            :before-upload="beforeUpload" @preview="handlePreview" @change="handleChange" name="file">
            <div v-if="ID_image.length < count">
                <a-icon type="plus" />
                <div class="ant-upload-text"></div>
            </div>
        </a-upload>
        <a-modal v-model="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>

</template>

<script>
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
export default {
    name: "index",
    props: {
        ID_image: {
            type: Array,
            default: () => {
                return []
            }
        },
        count: {
            type: Number,
            default: 1
        },
        isShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            uploadUrl: process.env.VUE_APP_NEW_URL + '/comapi/UploadApi',
            previewVisible: false,
            previewImage: '',
            hasWarned: false, // 防止重复提示
        }
    },
    methods: {
        beforeUpload(file, fileList) {
            // 检查当前已有文件数量加上即将上传的文件数量
            const currentCount = this.ID_image ? this.ID_image.length : 0;
            const totalCount = currentCount + fileList.length;
            
            if (totalCount > this.count) {
                // 只在第一次超出时提示
                if (!this.hasWarned) {
                    this.$message.warning(`最多只能上传${this.count}张图片,当前已有${currentCount}张,您选择了${fileList.length}张,超出限制`);
                    this.hasWarned = true;
                    setTimeout(() => { this.hasWarned = false; }, 2000);
                }
                return false;
            }
            
            return true;
        },
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                if (file.originFileObj instanceof Blob) {
                    file.preview = await getBase64(file.originFileObj);
                } else if (file.response && file.response.data && file.response.data.file_url) {
                    file.preview = file.response.data.file_url;
                } else if (typeof file === 'string') {
                    // If file is already a URL string
                    file = { url: file };
                } else {
                    console.error('Invalid file object:', file);
                    return;
                }
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handleCancel() {
            this.previewVisible = false;
        },
        handleChange({ fileList }) {
            // 限制最大数量
            if (fileList.length > this.count) {
                fileList = fileList.slice(0, this.count);
                // 只在第一次超出时提示
                if (!this.hasWarned) {
                    this.$message.warning(`最多只能上传${this.count}张图片`);
                    this.hasWarned = true;
                    setTimeout(() => { this.hasWarned = false; }, 2000);
                }
            }
            this.$emit('handleChange', fileList)
        }
    }
}
</script>

<style scoped></style>
